// dev/tourdeboteco/app/javascript/controllers/instagram_embed_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Verifica se já carregamos o script do Instagram
    if (!window.instgrm) {
      // Carrega o script do Instagram
      const script = document.createElement('script')
      script.src = 'https://www.instagram.com/embed.js'
      script.async = true
      script.defer = true
      script.title = 'Instagram Embed Script'
      document.body.appendChild(script)

      script.onload = () => {
        this.processEmbeds()
      }
    } else {
      this.processEmbeds()
    }

    // Observa mudanças no DOM para iframes adicionados dinamicamente
    this.observeIframes()
  }

  processEmbeds() {
    // Processa os embeds do Instagram quando o script estiver carregado
    if (window.instgrm) {
      window.instgrm.Embeds.process()

      // Aguarda um momento para os iframes serem criados e adiciona títulos
      setTimeout(() => {
        this.addTitlesToIframes()
      }, 1000)
    }
  }

  addTitlesToIframes() {
    // Encontra todos os iframes do Instagram e adiciona títulos
    const instagramIframes = document.querySelectorAll('iframe[src*="instagram.com"]')

    instagramIframes.forEach((iframe, index) => {
      if (!iframe.title) {
        iframe.title = `Post do Instagram ${index + 1} - Tour de Boteco`
        iframe.setAttribute('aria-label', `Conteúdo incorporado do Instagram ${index + 1}`)
      }
    })

    // Também verifica iframes dentro de blockquotes do Instagram
    const instagramBlockquotes = document.querySelectorAll('blockquote.instagram-media')
    instagramBlockquotes.forEach((blockquote, index) => {
      const iframe = blockquote.querySelector('iframe')
      if (iframe && !iframe.title) {
        iframe.title = `Post do Instagram ${index + 1} - Tour de Boteco`
        iframe.setAttribute('aria-label', `Post incorporado do Instagram ${index + 1}`)
      }
    })
  }

  observeIframes() {
    // Observa mudanças no DOM para capturar iframes adicionados dinamicamente
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Verifica se o nó adicionado é um iframe ou contém iframes
              const iframes = node.tagName === 'IFRAME' ? [node] : node.querySelectorAll?.('iframe') || []

              iframes.forEach((iframe, index) => {
                if (iframe.src && iframe.src.includes('instagram.com') && !iframe.title) {
                  iframe.title = `Post do Instagram ${index + 1} - Tour de Boteco`
                  iframe.setAttribute('aria-label', 'Conteúdo incorporado do Instagram')
                }
              })
            }
          })
        }
      })
    })

    // Observa mudanças no documento
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    // Salva o observer para limpeza posterior se necessário
    this.observer = observer
  }

  disconnect() {
    // Limpa o observer quando o controlador é desconectado
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}